import React from 'react';
import { IconProps } from './types/Icon.type';

function ArrowRight32Icon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5302 22.4695C12.2373 22.1766 12.2373 21.7017 12.5302 21.4088L18.4695 15.4696C18.7624 15.1767 19.2373 15.1767 19.5302 15.4696C19.823 15.7625 19.823 16.2373 19.5302 16.5302L13.5909 22.4695C13.298 22.7624 12.8231 22.7624 12.5302 22.4695Z"
        fill={props.fill ?? '#121212'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5302 16.5302C19.2373 16.8231 18.7625 16.823 18.4696 16.5302L12.5303 10.5909C12.2374 10.298 12.2374 9.82311 12.5303 9.53022C12.8232 9.23732 13.298 9.23732 13.5909 9.53022L19.5302 15.4696C19.823 15.7625 19.823 16.2373 19.5302 16.5302Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default ArrowRight32Icon;
